exports = module.exports = require("../../../../node_modules/react-scripts/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".center-holder {\n    display: flex;\n    align-items: center;\n    align-content: center;\n    justify-content: center;\n    position: absolute;\n    width: 100%;\n    height: 80%;\n    flex-direction: column;\n}\n\nspan.big-text {\n    font-size: 100pt;\n}", ""]);

// exports
